<div class="mla">
    <div class="mla-alert" *ngIf="canSubmit">
        <app-alert-info subjectMessage="Surveys: " uniqueID="labsattestation" contentMessage="Please take a few moments to complete one of the surveys below."></app-alert-info>
    </div>
    <div class="mla-alert" *ngIf="!canSubmit">
        <app-alert-danger subjectMessage=" " uniqueID="labsattestation1" contentMessage="Cannot submit for selected measurement period."></app-alert-danger>
    </div>        
    <div class="mla-meaurementperiod">
        <div class="mla-meaurementperiod-label">
            Measurement Period
        </div>
        <div class="mla-meaurementperiod-text">
            <p-dropdown [options]="measurementperiodlist" optionLabel="name" [(ngModel)]="selectedmeasurementperiod" (onChange)="onMPChange($event)"/>
        </div>        
    </div>
    <div class="mla-details-label" *ngIf="selectedassessment">
        <span style="color: #7D2350;font-weight: bold;">{{selectedassessment.name}} : </span>
        <span style="font-size: smaller;">{{selectedassessment.description}}</span>
    </div>
    <div class="mla-details">
        <div class="mla-details-left" *ngIf="!selectedassessment">
            <app-list-item [listItems]="displayassessments" (clickItem)="assessmentClicked($event)"></app-list-item>            
        </div>        
        <div class="mla-details-right" *ngIf="assessmentQuestions && selectedassessment">
            <report-wellness-survey (onItemChange)="oninputchange($event)" #reportwellnesssurvey></report-wellness-survey>
        </div>        
    </div>    
</div>
<app-continue-dialog key="continueDialog"></app-continue-dialog>
